import comp from "./StandardRubricEdit";
export default comp;
